// src/common/store/slices/promoSlice.ts
import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { PromoInterface } from '../../common/types/types'

interface PromoState {
  data: PromoInterface[]
}

const initialState: PromoState = {
  data: [],
}

export const promoSlice = createSlice({
  name: 'promo-list',
  initialState,
  reducers: {
    setPromos: (state, action: PayloadAction<PromoInterface[]>) => {
      state.data = action.payload
    },
  },
})

export const { setPromos } = promoSlice.actions

export const selectPromos = (state: RootState) => state.promoList.data

export const selectActivePromos = createSelector([selectPromos], (promos) =>
  promos.filter((promo) => promo.isActive),
)

export const selectPromoById = (promoId: number) =>
  createSelector([selectPromos], (promos) => promos.find((promos) => promos.id === promoId))

export default promoSlice.reducer
